import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { useDispatch } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { Input, Message, Button } from "../../../BP2Components";
import "./informationListSettings.less";

const { Option } = Select;

const InformationListSettings = ({ columns, rows, value }) => {
   const [settings, setSettings] = useState({ ...value });

   const dispatch = useDispatch();
   const intl = useIntl();

   useEffect(() => {
      setSettings({ ...settings });
   }, []);

   const isDefaultValueValid = (value) => {
      if (filterColumns().find(({ techName }) => techName === value)) {
         return true;
      } else {
         return false;
      }
   };

   const filterColumns = () => {
      return columns.filter(({ title }) => {
         let isValid = true;
         rows.forEach((row) => {
            if (
               row[title] instanceof Array ||
               (typeof row[title] === "object" && row[title] && !row[title].value)
            )
               isValid = false;
         });
         return isValid;
      });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChange = (value, name) => {
      setSettings(() => ({ ...settings, [name]: value }));
   };

   const displaySettings = [
      "photoColumnTechName",
      "dataColumnTechName",
      "titleColumnTechName",
      "contentColumnTechName",
      "authorColumnTechName",
      "isReadColumnTechName"
   ];

   return (
      <form onSubmit={handleSubmit}>
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label key="listId" className="widget-settings__inner__label">
                  <IntlMessages id="settings.listId" />:
                  <Input
                     onChange={(e) => handleChange(e.target.value, "listId")}
                     defaultValue={settings.listId}
                     name="listId"
                     id="listId"
                     className="listId"
                  ></Input>
               </label>
               <label key="itemsPerPage" className="widget-settings__inner__label">
                  <IntlMessages id="settings.itemsPerPage" />:
                  <Input
                     onChange={(e) => handleChange(e.target.value, "itemsPerPage")}
                     defaultValue={settings.itemsPerPage}
                     name="itemsPerPage"
                     id="itemsPerPage"
                     className="avdertisement-number-input"
                     type="number"
                  ></Input>
               </label>
               {displaySettings.map((labelName) => {
                  return (
                     <label
                        key={labelName}
                        className="widget-settings__inner__label select_and_switch"
                     >
                        <div className="select-container">
                           <p className="select-container-label">
                              <IntlMessages id={`newsletterList.${labelName}`} />
                           </p>
                           <Select
                              value={
                                 isDefaultValueValid(settings[labelName])
                                    ? settings[labelName]
                                    : "-"
                              }
                              style={{ width: 200 }}
                              onChange={(e) => handleChange(e, labelName)}
                           >
                              <Option value={"-"}>-</Option>
                              {filterColumns().map(({ title, techName }, i) => (
                                 <Option value={techName} key={i}>
                                    {title}
                                 </Option>
                              ))}
                           </Select>
                        </div>
                     </label>
                  );
               })}
            </div>
            <Button buttonType="primary" htmlType="submit">
               <IntlMessages id="global.preview" />
            </Button>
         </div>
      </form>
   );
};

export default InformationListSettings;
